// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-flex-module--wrapper--3IFpa"};